/**
 * Page with start rating and thank you at the end
 * 
 */

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Trans } from "react-i18next";
import i18n from  "./../../Documental/Localization/i18n.js";
import TopNav from  '../PatientApp/TopNav';
import StateMachine from 'react-simple-state/dist';
const appState = new StateMachine();

var timerCheckResources = null;
var timerProceedPoll = null;
var resourcesLoadedRef = false;
var resourcesLoadedRefCnt = 0;
var questionnaireResponseIdGlobal = "";

function FinishedPage() {
  const navigate = useNavigate();
  let currentAppMode = appState.getState( 'app-main-mode' );
  
  const [ privacyPolicyModalState, setPrivacyPolicyModalState ] = useState( "closed" );
  const [ resourcesLoaded, setResourcesLoaded ] = useState( false );
  const [ questionnaireId, setQuestionnaireId ] = useState( "" );
  const [ questionnaireResponseId, setQuestionnaireResponseId ] = useState( "" );
  const [ proceedClicked, setProceedClicked ] = useState( false );

  useEffect(() => {

    return function cleanup() {
      if ( timerProceedPoll != null) {
        //clearTimeout( timerProceedPoll );
      }
  
      if ( timerCheckResources != null) {
        clearTimeout( timerCheckResources );
      }
    };
  });
  
  
  const handleSkipClick = () => {

    return;
  }

  /**
   * If neede resources are loaded (Questionnaire Response and Questinnaire) 
   * procceed instantly. If not - poll for them to arrive. 
   * 
   * @returns void
   */
  const handleProceedClick = () => {
    if( resourcesLoadedRef === true ){
      navigate( './../questionnaire/' + questionnaireResponseId );
      return false;
    }
    
    if ( timerProceedPoll != null) {
      clearTimeout( timerProceedPoll );
    }

    if ( timerCheckResources != null) {
      clearTimeout( timerCheckResources );
    }
    
    setProceedClicked( true );
    pollProceedClick();
  }

  const handleLogoClick = () => {
    navigate( '/' );
    return false;
  }

  const handlePrivacyPolicyClick = () => {
    setPrivacyPolicyModalState( "opened" );
    return false;
  }

  const handlePrivacyPolicyClosed = () => {
    setPrivacyPolicyModalState( "closed" );
    return false;
  }

  const pollProceedClick = () => {
    if ( timerProceedPoll != null) {
      clearTimeout( timerProceedPoll );
    }
    
    if( resourcesLoadedRef ){

      if( resourcesLoadedRefCnt > 3 ){
        navigate( './../questionnaire/' + questionnaireResponseIdGlobal );
        return;
      }
      console.log( "resourcesLoadedRefCnt : " + resourcesLoadedRefCnt + " / " + questionnaireResponseIdGlobal );
      resourcesLoadedRefCnt++;
    }
    
    timerProceedPoll = setTimeout(function () {
      pollProceedClick();
    }, 250 );
  }

  const handleDebugClick = () => {
    console.log( "Debug" );
    console.log( window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "Patient"
    }) );
    return false;
  }

  

  const checkResourcesLoaded = () => {
    
    if( resourcesLoaded ){
      if ( timerCheckResources != null) {
        clearTimeout( timerCheckResources );
      }
      return;
    }
    
    var activityList = window.appEntityStore.getResourceById( 'fake-id-for-session-activity-list' );
    var loggedInPatient = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "Patient"
    });

    
    var q = null;
    var qr = null;

    if( activityList && loggedInPatient.length > 0 ){
      let res = activityList.toObject();
      let raw = res.entry[ 0 ].item.reference;
      let splitted = raw.split(  'QuestionnaireResponse/' );
      
      if( questionnaireResponseId === "" && splitted[ 1 ] ){
        questionnaireResponseIdGlobal = splitted[ 1 ];
        setQuestionnaireResponseId( splitted[ 1 ] );
      }
      
      qr = window.appEntityStore.getResourceById( splitted[ 1 ] );
      
      if( qr === null ){
        window.appEntityStore.requestResourceByReferenceUrl(
          res.entry[ 0 ].item.reference
        );
      } else {
        let questionnaireResponseJson = qr.toObject();
        let splitted2 = questionnaireResponseJson.questionnaire.split(  'Questionnaire/' );
        
        if( typeof splitted2[1] != "undefined" ){
          q = window.appEntityStore.getResourceById( splitted2[1] );
          if( q === null ){
            window.appEntityStore.requestResourceByReferenceUrl( questionnaireResponseJson.questionnaire );
          } else {
            setQuestionnaireId( splitted2[1] );
            resourcesLoadedRef = true;
            setResourcesLoaded( true );
            return;
          }
        }
      }
    }
  
    if ( timerCheckResources != null) {
      clearTimeout( timerCheckResources );
    }
  
    timerCheckResources = setTimeout(function () {
      checkResourcesLoaded();
    }, 500 );
   
  }

  checkResourcesLoaded();

  let buttonProceedClasses = "btn next mb-6";
  if( proceedClicked ){
    buttonProceedClasses = "btn loading-full mb-6";
  }

  



  let lang = i18n.language;

  /*
  https://docs.google.com/document/d/1D3wPP8Piw6raftB2wOVrHm-Yrrr3mjgwpTU4CoiQEn8/edit
  
  Kui pt ise jõuab DM lehele , siis on tekst: 
  Täname! Olete küsimustiku täitnud. Soovi korral saate broneerida aja arsti konsultatsioonile.
  Kui pt on saanud arstilt lingi ja täitnud küsimustiku ( self-report stsenaarium) ning selle ära saatnud siis on tekst: 
  Täname! Teie vastused on edastatud Teie raviarstile. 

  ,
        "You have completed the questionnaire." : "You have completed the questionnaire.",
        "If you wish, you can book an appointment for a doctor's consultation." : "If you wish, you can book an appointment for a doctor's consultation.",
        "Your answers have been forwarded to your doctor." : "Your answers have been forwarded to your doctor.",
  */

  //thankYouText = "Answers are saved"; // Olete küsimustiku täitnud
  let thankYouText = i18n.t( "You have completed the questionnaire." );
  
  if( 
    currentAppMode.appMainMode === "app-main-mode-free-assessment" || 
    currentAppMode.appMainMode === "app-main-mode-ukrainan"  
  ){
    // user would never end up here if chose booking in free-assessment. Will be redirected away
    thankYouText = i18n.t( "You have completed the questionnaire." );

      if(
        typeof window.mainResult !== 'undefined' && (
          typeof window.mainResult.patientWentToFillBookingForm === 'undefined' || (
            typeof window.mainResult.patientWentToFillBookingForm !== 'undefined' &&
            !window.mainResult.patientWentToFillBookingForm 
          )
        )
      ){
        thankYouText = thankYouText + ' ' + i18n.t( "If you wish, you can book an appointment for a doctor's consultation." );
      }

  } else if ( currentAppMode.appMainMode === "app-main-mode-ukrainan" ){
    // TODO: Ukraina modes jääb default "Answers are saved"? Sisuliselt sama mis siis free-assessment puhul, eemaldama selle ploki
  } else if ( 
    currentAppMode.appMainMode === "app-main-mode-default" || 
    currentAppMode.appMainMode === "app-main-mode-pre-appointment"
  ){
    thankYouText = i18n.t( "Your answers have been forwarded to your doctor." );
  }

  
  // repeat-vist has no thank you text
  if( currentAppMode.appMainMode === "app-main-mode-repeat-visit" ){
    thankYouText = "";
  }

  
  return (
    <div>
      

      <div className="app-page finished">
        <br />
        <br />
        <br />
        <div>
          <h1 className="mb-8 text-center"><Trans>Thank you</Trans>!</h1>
          <div className="text-center text-white">
            {thankYouText}
          </div>
        </div>
        <br />

        <div className="app-fragment pull-bottom-fixed">
          <div className="content-text">
          </div>
          
        </div>

      </div>
    </div>
  );
}

export default FinishedPage;